import React, { useState, type ReactNode } from 'react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { PageSection } from '~/shared/section/PageSection';
import { SearchInput } from '~/shared/forms/controls/base-controls/text-controls/SearchInput';
import type { SieveFilterModel } from '~/util/sieve/filter';
import { Button } from '~/shared/components/buttons/Button';
import { Section } from '~/shared/section/Section';

export function LibrarySection({
	librarySection,
	handleAdd,
	addLabel,
	searchPlaceholder,
	noResultsLabel,
	noResultsSubLabel,
	searchFilterColumn = 'name',
	TableComponent
}: {
	librarySection: SettingsSectionItem;
	handleAdd?: () => void;
	addLabel?: string;
	searchPlaceholder?: string;
	noResultsLabel: string;
	noResultsSubLabel: string;
	searchFilterColumn?: string;
	TableComponent: React.ComponentType<{ staticFilters?: SieveFilterModel[]; emptyMessage?: ReactNode }>;
}) {
	const [searchTerm, setSearchTerm] = useState('');
	const TitleIcon = librarySection.TitleIcon;
	const emptyMessage = (
		<div className="flex flex-col items-center gap-2 py-8 text-center">
			{TitleIcon ? <TitleIcon className="size-8 text-gray-300" /> : null}
			<p className="text-sm font-medium text-gray-700">{noResultsLabel}</p>
			<p className="text-xs text-gray-500">{searchTerm ? noResultsSubLabel : 'Try adjusting your search criteria'}</p>
		</div>
	);
	return (
		<PageSection {...librarySection} headerRightSlot={handleAdd ? <Button actionType="add" onClick={handleAdd} label={addLabel} /> : null}>
			<Section className="mb-8">
				<SearchInput value={searchTerm} onChange={setSearchTerm} placeholder={searchPlaceholder || 'Search...'} debounceMs={500} />
			</Section>
			<div className="overflow-hidden bg-white">
				<TableComponent
					staticFilters={searchTerm.length >= 3 ? [{ name: searchFilterColumn, operator: '@=', value: searchTerm }] : []}
					emptyMessage={emptyMessage}
				/>
			</div>
		</PageSection>
	);
}
